// extracted by mini-css-extract-plugin
export default {"textField":"MyInput_textField__KHL+n","input-wrapper":"MyInput_input-wrapper__Fa5RA","readOnly":"MyInput_readOnly__ibLXS"};